<template>
  <v-row justify="center">
    <ConfirmationModal
      :active="showModalConfirmation"
      :handleConfirm="handleAcceptConfirmModal"
      :handleCancel="handleCancelConfirmModal"
      title="Solicitar devolução"
      message="Você tem certeza que deseja solicicar devolução para esses dados informados?"
    />
    <v-dialog
      v-model="show"
      persistent
      max-width="350"
    >
      <v-card>
        <v-card-title class="text-h5">
          Dados para Devolução
        </v-card-title>
        <v-container fluid>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
          <v-text-field
            :rules="obrigatoryRules"
            required
            label="Nome Completo"
            maxlength="100"
            v-model="data.name"
            :disabled="viewDevolutionData"
          ></v-text-field>
          <v-text-field
            :disabled="viewDevolutionData"
            :rules="data.cpf ? cpfRules : []"
            required
            v-mask="'###.###.###-##'"
            label="CPF"
            maxlength="15"
            v-model="data.cpf"
          ></v-text-field>
          <v-text-field
            :disabled="viewDevolutionData"
            :rules="data.cnpj ? cnpjRules : []"
            v-mask="'##.###.###/####-##'"
            label="CNPJ"
            maxlength="18"
            v-model="data.cnpj"
          ></v-text-field>
          <v-autocomplete
            :disabled="viewDevolutionData"
            :rules="obrigatoryRules"
            required
            :items="banks"
            :filter="filterBank"
            item-value="code"
            item-text="fullName"
            no-data-text="Sem dados"
            v-model="data.code_bank"
            @change="getNameBank"
            label="Banco"
          ></v-autocomplete>
          <v-text-field
            :disabled="viewDevolutionData"
            :rules="obrigatoryAndNumberRules"
            required
            label="Agência"
            maxlength="6"
            v-model="data.ag"
          ></v-text-field>
          <v-select
            :disabled="viewDevolutionData"
            :items="[{ value: 'C', name:'Corrente' }, { value: 'P', name: 'Poupança' }]"
            item-text="name"
            item-value="value"
            label="Tipo de Conta"
            no-data-text="Sem dados"
            :rules="obrigatoryRules"
            v-model="data.type_account"
            required
            />
          <v-text-field
            :disabled="viewDevolutionData"
            :rules="obrigatoryAndNumberRules"
            required
            label="Conta"
            maxlength="10"
            v-model="data.account"
          ></v-text-field>
          <v-select
            :disabled="viewDevolutionData"
            :items="pixKeys"
            item-text="name"
            item-value="id"
            label="Tipo Chave Pix"
            no-data-text="Sem dados"
            v-model="data.pix_key_id"
            @change="getPixName"
          />
          <v-text-field
            :disabled="viewDevolutionData"
            v-mask="maskValuePix()"
            label="Valor Chave Pix"
            maxlength="300"
            v-model="data.pix_value"
          ></v-text-field>
          </v-form>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="show = false"
          >
            Cancelar
          </v-btn>

          <v-btn v-if="!viewDevolutionData" color="blue darken-1" :disabled="!valid" text @click="validate">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import { isCPF, isCNPJ } from 'brazilian-values'
  import brasil from '@/services/brasil'
  import message from '@/utils/message'
  import api from '@/services/api'
  import ConfirmationModal from '@/components/modals/ConfirmationModal'

  export default {
    components: {
      ConfirmationModal
    },
    data: () => ({
      obrigatoryAndNumberRules: [
        v => !!v || 'Informação obrigatória',
        v => /^-?\d+$/.test(v) || 'Informe apenas números'
      ],
      obrigatoryRules: [
        v => !!v || 'Informação obrigatória'
      ],
      cpfRules: [
        v => isCPF(v) || 'CPF deve ser válido'
      ],
      cnpjRules: [
        v => isCNPJ(v) || 'CNPJ deve ser válido'
      ],
      valid: true,
      banks: [],
      pixKeys: [],
      confirmModal: false
    }),
    props: {
      showModalDevolution: false,
      showConfirmation: false,
      viewDevolutionData: false,
      reserve: null,
      devolution: {
        name: null,
        cpf: null,
        cnpj: null,
        code_bank: null,
        name_bank: null,
        ag: null,
        type_account: null,
        account: null,
        pix_key_id: null,
        pix_key_name: null,
        pix_value: null
      }
    },
    created () {
      this.getBanks()
      this.getPixKeys()
    },
    methods: {
      handleCancelConfirmModal () {
        this.showModalConfirmation = false
      },

      handleAcceptConfirmModal () {
        this.showModalConfirmation = false
        this.$emit('save-devolution')
      },
      async getBanks () {
        try {
          const { data } = await brasil.get('banks/v1')
          this.banks = data.filter(value => value.code !== null)
          this.banks.sort((a, b) => (a.fullName.replace(`"`, '') > b.fullName.replace(`"`, '') ? 1 : -1))
        } catch (error) {
          message.error('Erro ao buscar a lista de bancos')
        }
      },
      async getPixKeys () {
        try {
          const { data } = await api.get('pix-keys')
          this.pixKeys = data
        } catch (error) {
          message.error('Erro ao buscar a lista de chaves')
        }
      },
      filterBank (item, queryText, _itemText) {
        return item.name.toLowerCase().indexOf(queryText.toLowerCase()) > -1
      },
      validate () {
        if (this.$refs.form.validate()) {
          this.showModalConfirmation = true
        }
      },
      maskValuePix () {
        if (this.data.pix_key_id === 1 && !this.viewDevolutionData && this.reserve) {
          if (this.data.pix_value !== this.reserve.client.cnpj && this.data.pix_value !== this.reserve.client.cpf) {
            return this.data.pix_value && this.data.pix_value.length > 14 ? '##.###.###/####-##' : '###.###.###-##'
          }
        } else if (this.data.pix_key_id === 2 && !this.viewDevolutionData && this.reserve) {
          if (this.data.pix_value !== `${this.reserve.client.ddd_cell} ${this.reserve.client.cell}`) {
            return '(##) #####-####'
          }
        }
      },
      getNameBank () {
        const info = this.banks.find(bank => bank.code === this.devolution.code_bank)
        this.devolution.name_bank = info.fullName || null
      },
      getPixName () {
        const info = this.pixKeys.find(pixkey => pixkey.id === this.devolution.pix_key_id)
        this.devolution.pix_key_name = info.name || null
        const client = this.reserve.client
        if (info.id === 1) {
          this.data.pix_value = client.cnpj ? client.cnpj : client.cpf
        } else if (info.id === 2) {
          this.data.pix_value = `${client.ddd_cell} ${client.cell}`
        } else if (info.id === 3) {
          this.data.pix_value = client.email
        }
      }
    },
    computed: {
      show: {
        get () {
          return this.showModalDevolution
        },
        set (value) {
          this.$emit('update:showModalDevolution', value)
        }
      },
      data: {
        get () {
          return this.devolution
        },
        set (value) {
          this.$emit('update:devolution', value)
        }
      },
      showModalConfirmation: {
        get () {
          return this.showConfirmation
        },
        set (value) {
          this.$emit('update:showConfirmation', value)
        }
      }
    },
    watch: {
      reserve (newValue, _oldValue) {
        if (newValue) {
          this.data.name = newValue.client.name
          if (!newValue.client.cnpj) {
            this.data.cpf = newValue.client.cpf
          }
          this.data.cnpj = newValue.client.cnpj
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modals/DevolutionModal.vue